import * as React from "react";
import { TouchableOpacity, StyleSheet, View, Text } from "react-native";

import { Container } from "native-base";
import { observer } from "mobx-react/native";

import SalesList from "../SalesList/index";
import SalesReceipt from "../SalesReceipt/index";
import GrandTotalComponent from "@components/GrandTotalComponent";

import ViewOrderComponent from "../../components/ViewOrderComponent";
import ChangeTableComponent from "../../components/ChangeTableComponent";
import CategoriesComponent from "@components/CategoriesComponent";

import Icon from "react-native-vector-icons/FontAwesome";

import SearchComponent from "@components/SearchComponent";
import { currentLanguage } from "../../../translations/CurrentLanguage";
import translation from "../../../translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors } from "../../../theme/modern";

let strings = new LocalizedStrings(translation);
@observer
class Sales extends React.PureComponent {
  onItemClick = index => this.props.onItemClick(index);
  onReceiptLineDelete = index => this.props.onReceiptLineDelete(index);
  onCategoryClick = (id, index) => this.props.onCategoryClick(id, index);
  navigate = () => this.props.navigation.navigate("DrawerOpen");
  onSearchClick = () => this.props.onSearchClick(true);
  onCategoryEndReached = () => this.props.onEndReached("category");
  onPressCategory = (id, index) => this.props.onCategoryClick(id, index);

  renderOrder() {
    const {
      onCloseViewOrder,
      isLoadingOrder,
      onTableClick,
      orders,
      onTableLongPress,
      inTableOptions,
      newTableNumber,
      setNewTableNumber,
      onChangeTable,
      onCloseTable,
      onReprintOrder,
      company,
    } = this.props;

    return inTableOptions ? (
      <ChangeTableComponent
        newTableNumber={newTableNumber}
        setNewTableNumber={setNewTableNumber}
        onChangeTable={onChangeTable}
        onCloseTable={onCloseTable}
        onReprintOrder={onReprintOrder}
      />
    ) : (
      <ViewOrderComponent
        company={company}
        orders={orders}
        length={orders.length}
        onTableClick={onTableClick}
        isLoadingOrder={isLoadingOrder}
        onCloseViewOrder={onCloseViewOrder}
        onTableLongPress={onTableLongPress}
      />
    );
  }
  renderSearch() {
    const { onSearchClick, onChangeSalesSearchText } = this.props;
    return (
      <SearchComponent
        status="Sales"
        onSearchClick={onSearchClick}
        onChangeText={onChangeSalesSearchText}
      />
    );
  }

  renderHeader() {
    return (
      <View style={styles.header}>
        <TouchableOpacity onPress={this.navigate} style={styles.headerButton}>
          <Icon size={20} name="bars" color="white" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>{strings.Sales}</Text>
        <TouchableOpacity
          onPress={this.onSearchClick}
          style={styles.headerButton}
        >
          <Icon size={18} name="search" color="white" />
        </TouchableOpacity>
      </View>
    );
  }

  renderTotal() {
    const {
      currency,
      receiptDefault,
      onViewOrders,
      isViewingOrder,
      onTakeAwayClick,
      hasTailOrder,
      currentTable,
      onCancelOrder,
      isCurrencyDisabled,
      roundOff,
    } = this.props;
    return (
      <GrandTotalComponent
        onTakeAwayClick={onTakeAwayClick}
        isViewingOrder={isViewingOrder}
        currentTable={currentTable}
        onCancelOrder={onCancelOrder}
        receipt={receiptDefault}
        isCurrencyDisabled={isCurrencyDisabled}
        currency={currency}
        hasTailOrder={hasTailOrder}
        onViewOrders={onViewOrders}
        grandTotal={
          receiptDefault
            ? roundOff
              ? receiptDefault.netTotalRoundOff
              : receiptDefault.netTotal.toFixed(2)
            : "0.00"
        }
      />
    );
  }

  render() {
    const {
      currency,
      itemData,
      navigation,
      categoryData,
      searchStatus,
      onCloseClick,
      onSearchClick,
      bluetoothStatus,
      salesListStatus,
      onBarcodeRead,
      onBluetoothScan,
      onEndReached,
      itemsLength,
      categoryLengths,
      barcodeScannerInput,
      onChangeSalesSearchText,
      onChangeBarcodeScannerInput,
      selectedCategoryIndex,
      onLongPressItem,

      // Sales Receipt
      receiptDefault,
      isDiscountsEmpty,
      onViewOrders,
      onDeleteClick,
      onBarcodeClick,
      onDiscountClick,
      onPaymentClick,
      onReceiptLineEdit,

      // New feature
      isViewingOrder,
      onTakeAwayClick,
      hasTailOrder,
      useDescription,
      currentTable,
      onCancelOrder,
      isCurrencyDisabled,
      listStatus,
      company,
      enableOverallTax,
      roundOff,
    } = this.props;
    strings.setLanguage(currentLanguage().companyLanguage);
    return (
      <Container style={styles.screen}>
        <View style={styles.columns}>
          <View style={styles.catalog}>
            {!company.hideMenuBar
              ? searchStatus
                ? this.renderSearch()
                : this.renderHeader()
              : null}
            {isViewingOrder ? (
              this.renderOrder()
            ) : (
              <View style={styles.fill}>
                <CategoriesComponent
                  data={categoryData}
                  hideMenuBar={company.hideMenuBar}
                  disabled={searchStatus}
                  itemsLength={itemsLength}
                  catLengths={categoryLengths}
                  bluetoothStatus={bluetoothStatus}
                  onCategoryClick={this.onPressCategory}
                  onEndReached={this.onCategoryEndReached}
                  selectedCategoryIndex={selectedCategoryIndex}
                />
                <SalesList
                  company={company}
                  listStatus={listStatus}
                  isCurrencyDisabled={isCurrencyDisabled}
                  currency={currency}
                  itemData={itemData}
                  navigation={navigation}
                  categoryData={categoryData}
                  searchStatus={searchStatus}
                  bluetoothStatus={bluetoothStatus}
                  salesListStatus={salesListStatus}
                  onChangeSalesSearchText={onChangeSalesSearchText}
                  onChangeBarcodeScannerInput={onChangeBarcodeScannerInput}
                  onCloseClick={onCloseClick}
                  onItemClick={this.onItemClick}
                  barcodeScannerInput={barcodeScannerInput}
                  onSearchClick={onSearchClick}
                  onBarcodeRead={onBarcodeRead}
                  selectedCategoryIndex={selectedCategoryIndex}
                  onBluetoothScan={onBluetoothScan}
                  onCategoryClick={this.onCategoryClick}
                  onEndReached={onEndReached}
                  itemsLength={itemsLength}
                  categoryLengths={categoryLengths}
                  onLongPressItem={onLongPressItem}
                  // Descriptive items
                  useDescription={useDescription}
                />
              </View>
            )}
          </View>

          <View style={styles.order}>
            {this.renderTotal()}
            <SalesReceipt
              enableOverallTax={enableOverallTax}
              isCurrencyDisabled={isCurrencyDisabled}
              currency={currency}
              receipt={receiptDefault}
              isDiscountsEmpty={isDiscountsEmpty}
              onViewOrders={onViewOrders}
              onDeleteClick={onDeleteClick}
              onBarcodeClick={onBarcodeClick}
              onPaymentClick={onPaymentClick}
              onDiscountClick={onDiscountClick}
              onReceiptLineEdit={onReceiptLineEdit}
              onReceiptLineDelete={this.onReceiptLineDelete}
              onTakeAwayClick={onTakeAwayClick}
              hasTailOrder={hasTailOrder}
              // Table
              currentTable={currentTable}
              onCancelOrder={onCancelOrder}
              // Order
              isViewingOrder={isViewingOrder}
              roundOff={roundOff}
            />
          </View>
        </View>
      </Container>
    );
  }
}

export default Sales;
const styles = StyleSheet.create({
  screen: {
    backgroundColor: colors.background,
  },
  columns: {
    flex: 1,
    flexDirection: "row",
  },
  fill: {
    flex: 1,
  },
  catalog: {
    flex: 1,
    minWidth: 0,
  },
  order: {
    width: "32%",
    minWidth: 330,
    maxWidth: 440,
    backgroundColor: colors.surface,
    borderLeftWidth: 1,
    borderLeftColor: colors.border,
  },
  header: {
    height: 60,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 8,
    backgroundColor: colors.navy,
  },
  headerButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    alignItems: "center",
    justifyContent: "center",
  },
  headerTitle: {
    flex: 1,
    marginLeft: 6,
    color: "#fff",
    fontSize: 18,
    fontWeight: "700",
  },
});
